export const RESET_PASSWORD_URL = '/api/reset-password/v1';

// see app/view/static/js/zr-validate-additional-methods.js method pwcheck
export const PW_CHECK_REGEX = /^1+$|^123456$|^qwerty$|^abcdef$|^admin$|^password/;

export const MINIMUM_PASSWORD_LENGTH = 8;

export const THRESHOLD_GOOD_PASSWORD_LENGTH = 12;

export const THRESHOLD_VERY_GOOD_PASSWORD_LENGTH = 16;

export const TOO_COMMON_ERROR = 'This password is too common.';

export const TOO_SHORT_ERROR = `Password must be at least ${MINIMUM_PASSWORD_LENGTH} characters.`;
